var JsonWebTokenError = require('./JsonWebTokenError');

var NotBeforeError = function (message, date) {
  JsonWebTokenError.call(this, message);
  this.name = 'NotBeforeError';
  this.date = date;
};

NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);

NotBeforeError.prototype.constructor = NotBeforeError;

module.exports = NotBeforeError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonwebtoken/lib/NotBeforeError.js
 ** module id = 1298
 ** module chunks = 0
 **/